export default [
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_side-income.png',
    subTitle: 'Jadilah pengemudi airasia ride dengan mengantarkan penumpang sampai ke tujuannya dan dapatkan uang tambahan selama waktu luang Anda.',
    title: 'Dapatkan Penghasilan Sampingan'
  },
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_flexible-hours.png',
    subTitle: 'Dengan airasia ride, Anda dapat bekerja di mana pun Anda mau, kapan pun Anda mau!',
    title: 'Waktu Kerja Fleksibel'
  },
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_incentive.png',
    subTitle: 'Sebagai pengemudi airasia ride, Anda akan mendapatkan bonus yang kompetitif serta potongan komisi rendah. Anda bisa mendapatkan lebih banyak penghasilan.',
    title: 'Insentif dan Potongan Komisi Rendah'
  }
]
